// Kept local so the frontend continues to use its established role-to-
// permission definitions instead of receiving UI permissions from the API.
export const rolePermissions = {
  admin: [
    "unifiedData.view", "unifiedData.edit", "medianUnifiedData.view", "medianUnifiedData.edit",
    "eventData.view", "eventData.edit", "notificationData.view", "queueData.view", "queueData.edit",
    "home.view", "home.edit", "queue.view", "queue.edit", "lineChart.view", "lineChart.edit",
    "detailBarChart.view", "detailBarChart.edit", "gaugeChart.view", "gaugeChart.edit",
    "details.view", "details.edit", "analytics.view", "map.view", "map.edit", "events.view",
    "calendar.view", "calendar.edit", "fullCalendar.view", "fullCalendar.edit",
    "communityUsers.view", "communityUsers.edit", "community.view", "parcels.view", "parcels.edit",
    "table.view", "table.edit", "interactiveTable.view", "interactiveTable.edit",
    "comparativeTable.view", "comparativeTable.edit", "analyticsLineChart.view", "analyticsLineChart.edit",
    "filteredDataTable.view", "filteredDataTable.edit", "profile.view", "profile.edit",
    "settings.view", "settings.edit",
  ],
  tecnico: [
    "unifiedData.view", "medianUnifiedData.view", "medianUnifiedData.edit", "eventData.view", "eventData.edit",
    "notificationData.view", "queueData.view", "home.view", "queue.view", "lineChart.view", "lineChart.edit",
    "barChart.view", "barChart.edit", "detailBarChart.view", "detailBarChart.edit", "gaugeChart.view",
    "gaugeChart.edit", "details.view", "details.edit", "analytics.view", "map.view", "map.edit",
    "events.view", "calendar.view", "fullCalendar.view", "fullCalendar.edit", "parcels.view",
    "communityUsers.view", "community.view", "interactiveTable.view", "interactiveTable.edit",
    "comparativeTable.view", "comparativeTable.edit", "analyticsLineChart.view", "analyticsLineChart.edit",
    "filteredDataTable.view", "filteredDataTable.edit", "profile.view", "profile.edit", "settings.view", "settings.edit",
  ],
  regante: [
    "unifiedData.view", "medianUnifiedData.view", "queueData.view", "home.view", "map.view", "queue.view",
    "queue.edit", "communityUsers.view", "community.view", "profile.view", "profile.edit", "settings.view", "settings.edit",
  ],
  guest: ["medianUnifiedData.view", "queueData.view", "home.view", "map.view", "queue.view"],
};

export const getRolePermissions = (role) => rolePermissions[role] || rolePermissions.guest;
